module.exports = {"TXTCLI_Back":{"id":"TXTCLI_Back","defaultMessage":"Vissza","flags":["TRACK"],"track":"Back"}}